import React, { useMemo } from "react"
import { useStageContext } from "@/components/Menu/Mobile/Stages/index"
import styled from "styled-components"
import WWDLink from "@/components/Menu/Shared/WWDLink"
import Category from "@/components/Menu/Mobile/Category"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { PAGES } from "@/constants"

const SectionWrapper = styled.div`
	--row-gap: ${({ theme }) => getCssSizeValue(theme.spacing[BREAKPOINTS.MOBILE].m, BREAKPOINTS.MOBILE)};
	display: flex;
	flex-direction: column;
	row-gap: var(--row-gap);

	&.up {
		margin-bottom: var(--row-gap);
		padding-bottom: var(--row-gap);
		border-bottom: solid 1px ${({ theme }) => theme.colors.chineseViolet};
	}
`
const WWDHeader = styled(WWDLink)`
	font-weight: ${({ theme }) => theme.fontWeight.bold} !important;
	color: ${({ theme }) => theme.colors.periwinkle} !important;
`
const Section = ({ data, down = false }) => {
	const items = data || []
	return (
		<SectionWrapper className={`${down ? "down" : "up"} px-main`} data-scroll-ignore-lock>
			{!down && <WWDHeader />}
			{items.map((item, index) => {
				if (!item) return
				return <Category key={item?.id || index} data={item} />
			})}
		</SectionWrapper>
	)
}

const Stage0 = () => {
	const { items } = useStageContext()
	const [up, down] = useMemo(() => {
		const up = items.slice(0, 3)
		const infoChildren = items.find((item) => item.isInfoCategory)?.children || []
		const filteredInfo = infoChildren?.filter((item) => item?.universalLink?.link?.link?.slug !== PAGES.I_PAY)

		const help = items.slice(4, 6)
		const shortcuts = items.find((item) => item.isShortcutsCategory)
		const down = [items[3], ...help, items[6], ...filteredInfo]

		// console.log(info);

		return [up, down, shortcuts]
	}, [items])
	return (
		<>
			<Section data={up} />
			<Section data={down} down />
		</>
	)
}

export default Stage0
